import { useEffect, useState } from "react";

const Loader = ({ onDone }) => {
  const [count, setCount] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    let raf;
    let start = null;
    let held = 0;
    const dur = 1500;
    const holdFrames = 24;
    const run = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.floor(eased * 100));
      if (p < 1) {
        raf = requestAnimationFrame(run);
      } else if (held < holdFrames) {
        held += 1;
        raf = requestAnimationFrame(run);
      } else {
        setCount(100);
        setLeaving(true); // triggers CSS slide-up -> onTransitionEnd -> onDone
      }
    };
    raf = requestAnimationFrame(run);
    return () => cancelAnimationFrame(raf);
  }, []);

  const handleTransitionEnd = (e) => {
    if (e.propertyName === "transform" && leaving) onDone && onDone();
  };

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-ink grain transition-transform duration-[800ms] ease-[cubic-bezier(0.76,0,0.24,1)] ${
        leaving ? "-translate-y-full" : "translate-y-0"
      }`}
      data-testid="page-loader"
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="blueprint-grid absolute inset-0 opacity-40" />
      <div className="relative flex flex-col items-center">
        <div className="overflow-hidden">
          <h1
            className="animate-[rise_0.9s_cubic-bezier(0.16,1,0.3,1)_forwards] font-display text-6xl font-bold tracking-tight text-white sm:text-7xl"
            style={{ transform: "translateY(0)" }}
          >
            PAHI
          </h1>
        </div>
        <p className="mt-3 text-xs uppercase tracking-[0.4em] text-steel">Technocrate</p>

        <div className="mt-10 h-px w-56 overflow-hidden bg-white/10">
          <div className="h-full bg-brand-soft transition-[width] duration-100" style={{ width: `${count}%` }} />
        </div>
        <div className="mt-4 font-display text-sm tabular-nums text-steel">{count}%</div>
      </div>
      <div className="absolute bottom-8 text-[10px] uppercase tracking-[0.3em] text-white/30">
        Precision Engineered. Performance Assured.
      </div>
    </div>
  );
};

export default Loader;
